import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'app/data.service';

@Component({
  selector: 'app-add-districts',
  templateUrl: './add-districts.component.html',
  styleUrls: ['./add-districts.component.css']
})
export class AddDistrictsComponent implements OnInit {

  constructor(private dataService : DataService) { }

  provincesData:any[];
  response: string[];
  status: boolean;

  districtData: FormGroup = new FormGroup({
    province_id: new FormControl('', [Validators.required]),
    district: new FormControl('',[Validators.required])
  })

  ngOnInit(): void {
  	this.dataService.states()
  		.subscribe((provinces:any) => {
  			this.provincesData = provinces.provinces;
  		})
  }

  submitDistrictData(data:any){
  	this.dataService.submitDistricts(data)
  		.subscribe((response:any)=>{
  			this.response = response.message;
        this.status = response.status;
  		})
  }
}
